export default function useStaticResumeChartOptions(color) {
  const chartOptions = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
      sparkline: {
        enabled: true,
      },
    },
    grid: {
      show: false,
    },
    colors: [color],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '30%',
        startingShape: 'rounded',
        endingShape: 'rounded',
        borderRadius: 4,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: false,
    },
    tooltip: {
      x: {
        show: false,
      },
    },
  }

  const data = []

  for (let i = 0; i < 7; i += 1) {
    const num = Math.floor(Math.random() * (110 - 40 + 1)) + 40
    data.push(num)
  }

  const randomSeries = [
    {
      name: '',
      data,
    },
  ]

  return {
    chartOptions,
    randomSeries,
  }
}
